import Image from "../Image";

/**
 * 花瓣Logo
 * @param {{
 *  size?: number,
 *  width?: number,
 *  height?: number,
 *  hasText?: boolean,
 * }} props
 * @returns
 */
export default function HBLogo({ size = 24, width, height, hasText = false }) {
  const src = hasText
    ? "https://st0.dancf.com/static/02/202112300712-b428.svg"
    : "https://cdn.dancf.com/fe-assets/20250424/3277dc6bd2124e104a49b0a0b6a95997.svg";

  return (
    <Image
      src={src}
      alt="花瓣网"
      width={width || size}
      height={height || size}
      loading={"eager"}
    />
  );
}
